import React, { useState, createContext } from "react";
import { FormInput } from "components/items";
import { alertDone } from "function/alert";
import { inputPhoneNumber } from "function/telPattern";

export const FormContext = createContext();

const TEMPLATE_ID = "template_goXmQAsW";
const SERVICE_ID = "default_service";

const formInit = {
	from_brand: "",
	from_email: "",
	message_html: "",
	from_name: "",
	from_tel: "",
};

const Form = ({ setIsLoading }) => {
	const [form, setForm] = useState(formInit);
	const [fileName, setFileName] = useState("업로드");

	// send email
	const onSubmitHandle = async (e) => {
		setIsLoading(true);
		e.preventDefault();
		const formDom = e.target;
		const messageArr = e.target.message_html.value.split("\n").map((el) => `${el}<br/>`);
		let messageStr = "";
		messageArr.forEach((el) => {
			messageStr = messageStr + el;
		});

		formDom.message_html.value = messageStr;

		await sendFeedback(SERVICE_ID, TEMPLATE_ID, formDom);
	};

	const sendFeedback = (serviceId, templateId, userForm) => {
		window.emailjs
			.sendForm(serviceId, templateId, userForm)
			.then((res) => {
				console.log("Email successfully sent!");
				setIsLoading(false);
				setForm(formInit);
				setFileName("업로드");
				alertDone();
				window.location.reload();
			})
			.catch((err) => console.error("Oh well, you failed. Here some thoughts on the error that occured:", err));
	};

	// on change form
	const onChangeHandle = (e) => {
		const name = e.target.name;
		let value = e.target.value;
		if (e.target.type === "file") {
			onFileChangeHandle(e);
		}
		if (e.target.type === "tel") {
			value = inputPhoneNumber(e.target);
		}
		setForm({
			...form,
			[name]: value,
		});
	};

	// on file change appear label name
	const onFileChangeHandle = (e) => {
		if (window.FileReader) {
			// modern browser
			const filename = e.target.files[0].name;
			setFileName(filename);
		} else {
			// old IE
			const filename = e.target.val().split("/").pop().split("\\").pop();
			setFileName(filename);
		}
	};

	return (
		<FormContext.Provider value={{ onChangeHandle, form }}>
			<form onSubmit={onSubmitHandle} className="Form">
				<div className="form-row">
					<FormInput placeholder="업체명*" type="text" name="from_brand" required={true} />
					<FormInput placeholder="성명/직책*" type="text" name="from_name" required={true} />
					<FormInput placeholder="연락처*" type="tel" name="from_tel" required={true} />
				</div>

				<div className="form-row">
					<FormInput placeholder="이메일*" type="email" name="from_email" required={true} />
				</div>

				<div className="form-row">
					<FormInput placeholder="문의 내용을 작성해주세요." type="text" name="message_html" required={true} />
				</div>

				<div className="form-row upload">
					<FormInput placeholder="첨부파일 추가" type="file" name="from_file" fileName={fileName} />
				</div>

				<div className="form-row">
					<FormInput placeholder="상담 문의하기" type="submit" value="상담 문의하기" name="client-send" />
				</div>
			</form>
		</FormContext.Provider>
	);
};

export default Form;
